import React, { FunctionComponent, memo, useEffect, useState } from "react";
import "./HamburgerButton.scss";

export interface HamburgerButtonProps {
  isOpen: boolean;
  clickHandler: () => void;
}

const HamburgerButton: FunctionComponent<HamburgerButtonProps> = memo(
  ({ isOpen, clickHandler }) => {
    const [isReversing, setIsReversing] = useState<boolean>(false);

    useEffect(() => {
      if (isOpen) setIsReversing(true);
      else
        setTimeout(() => {
          setIsReversing(false);
        }, 300);
    }, [isOpen]);

    return (
      <button className="HamburgerButton" onClick={clickHandler}>
        <div
          className={`HamburgerButton__burger ${isOpen ? "isActive" : ""} ${
            isReversing ? "Reverse" : ""
          }`}
        >
          <div className="HamburgerButton__burger_box">
            <div className="HamburgerButton__burger_inner"></div>
          </div>
        </div>
      </button>
    );
  }
);

export default HamburgerButton;
